<template>
    <div class="progress-result">
        <div class="progress-result_empty flex-center" v-if="resultList.length === 0">
            <img src="@/assets/img/task-center/process-empty.png" alt="" />
            <span>当前筛选条件暂无数据......</span>
        </div>

        <div class="progress-result_list" v-else>
            <ProcessItem
                :result="result"
                :first="index === 0"
                :last="index === resultList.length - 1"
                v-for="(result, index) in resultList"
                :key="result.id"
            ></ProcessItem>
        </div>
    </div>
</template>

<script>
import ProcessItem from "./ProcessItem.vue";

export default {
    data() {
        return {};
    },

    props: {
        resultList: {
            type: Array,
            default: () => [],
        },
    },

    components: {
        ProcessItem,
    },
};
</script>

<style lang="scss" scoped>
.progress-result {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;

    &_empty {
        height: 500px;
        background-color: #ffffff;
        flex-direction: column;
        gap: 20px;

        img {
            height: 280px;
            width: auto;
            object-fit: cover;
        }

        span {
            font-weight: 400;
            font-size: 16px;
            color: #666666;
        }
    }

    &_list {
        padding: 20px 60px;
        background-color: #fff;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    }
}
</style>
